/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BrokernetNotificationChannel {
    Email = 'Email',
    Browser = 'Browser',
    FirebasePush = 'FirebasePush'
  }

    export const BrokernetNotificationChannelTranslocoMap: Record<BrokernetNotificationChannel, string> = {
    [BrokernetNotificationChannel.Email]: 'brokernetNotificationChannel.email',
    [BrokernetNotificationChannel.Browser]: 'brokernetNotificationChannel.browser',
    [BrokernetNotificationChannel.FirebasePush]: 'brokernetNotificationChannel.firebasePush',
    };

    export const BrokernetNotificationChannelOptions = [
  { value: BrokernetNotificationChannel.Email, labelKey: 'brokernetNotificationChannel.email' },
  { value: BrokernetNotificationChannel.Browser, labelKey: 'brokernetNotificationChannel.browser' },
  { value: BrokernetNotificationChannel.FirebasePush, labelKey: 'brokernetNotificationChannel.firebasePush' },
    ];

